<template>
  <div class="historycomment-list">
    <Form :model="formItem"
          ref="formItem"
          :inline="true"
          action="javascript:void(0)">
      <FormItem>
        <Input v-model="formItem.key"
               placeholder="输入商品标题"
               style="width:200px"></Input>
      </FormItem>
      <FormItem>
        <Button type="primary"
                @click="renderTable('formItem')">筛选</Button>
      </FormItem>
    </Form>
    <Table border
           :columns="columns"
           ref="selection"
           :data="tablelist"
           :loading="dataloading"></Table>
    <div style="margin: 10px;overflow: hidden">
      <div style="float: right;">
        <Page ref="listPage"
              :total="pages.total"
              :current="pages.page"
              :page-size="pages.size"
              show-elevator
              show-total
              @on-change="changePage()"></Page>
      </div>
    </div>
        <!-- 图片查看 start -->
    <viewer
      :options="viewerOptions"
      :images="viewerImages"
      @inited="inited"
      class="viewerImageWraper"
      ref="viewerImageWraper"
    >
      <template slot-scope="scope">
        <figure class="images">
          <div class="image-wrapper" v-for="img in viewerImages" :key="img">
            <img class="image" :src="img" :data-source="img" :alt="img" style="display: none;" />
          </div>
        </figure>
      </template>
    </viewer>
    <!-- 图片查看 end -->
  </div>
</template>

<script>
export default {
  name: "historycomment-list",
  data () {
    return {
       viewerOptions: {
        toolbar: true,
        url: "data-source"
      },
      viewerImages: [],
      title: "",
      dataloading: true,
      formItem: {},
      modal1: false,
      pages: {
        current: 1,
        total: 0,
        size: 20
      },
      columns: [
        {
          title: "Id",
          key: "id",
          width: 80
        },
        {
          title: "商品标题",
          minWidth: 300,
          key: "title"
        },
        {
          title: "评论内容",
          minWidth: 300,
          key: "comment"
        },
        {
          title: "相册",
          key: "attrs",
          width: 300,
          render: (h, params) => {
            var that = this;
            if (params.row.attrs == null) {
              return;
            }
            var il = JSON.parse(params.row.attrs);
            var imgListObj = new Array();
            var ossurl = this.$publicData.ossUrl;
            for (var i = 0; i < il.length; i++) {
              var showImg = ossurl+il[i];
              imgListObj.push(
                h("img", {
                  style: {
                    width: "50px",
                    height: "50px"
                  },
                  attrs: {
                    src: showImg
                  },
                  on: {
                    click: function (e) {
                      that.visible = true;
                      that.imgUrl = e.srcElement.src;
                      that.viewerImages = [e.srcElement.src];
                      that.$viewer.show();
                    }
                  }
                })
              );
            }
            return h("div", imgListObj);
          }
        },
        {
          title: "用户名",
          minWidth: 200,
          key: "username"
        },
        {
          title: "发布时间",
          minWidth: 200,
          key: "created_at"
        },
        {
          title: "状态",
          width: 150,
          key: "status",
          render: (h, params) => {
            return h("div", [
              h("span", {}, params.row.status == "1" ? "下架" : "上架")
            ]);
          }
        },
        {
          title: "操作",
          key: "action",
          width: 330,
          align: "left",
          fixed: "right",
          render: (h, params) => {
            return h("div", [
              h(
                "Button",
                {
                  props: {
                    type: "primary",
                    size: "small"
                  },
                  style: {
                    marginRight: "5px",
                    display: params.row.status == "1" ? "inline-block" : "none"
                  },
                  on: {
                    click: () => {
                      this.review(params.row.id, 0);
                    }
                  }
                },
                "上架"
              ),
              h(
                "Button",
                {
                  props: {
                    type: "warning",
                    size: "small"
                  },
                  style: {
                    marginRight: "5px",
                    display: params.row.status == "0" ? "inline-block" : "none"
                  },
                  on: {
                    click: () => {
                      this.review(params.row.id, 1);
                    }
                  }
                },
                "下架"
              ),
              h(
                "Button",
                {
                  props: {
                    type: "error",
                    size: "small"
                  },
                  style: {
                    marginRight: "5px",
                  },
                  on: {
                    click: () => {
                      this.remove(params.row.id);
                    }
                  }
                },
                "删除"
              )
            ]);
          }
        }
      ],
      tablelist: []
    };
  },
  components: {},
  // 计算
  computed: {},
  // 监听
  watch: {},
  created: function () {
    // 取数据
    this.getTableList();
  },
  methods: {
    inited(viewer) {
      this.$viewer = viewer;
    },
    getTableList: function () {
      var self = this;
      var params = { page: this.pages.current, size: this.pages.size };
      this.$api.goods.commentlist(params).then(res => {
        this.dataloading = false;
        if (res.code == 200) {
          self.tablelist = res.result.list;
          this.pages.total = res.result.total;
          this.$Message.success(res.msg);
        }
      });
      return;
    },
    changePage () {
      this.pages.current = this.$refs["listPage"].currentPage;
      this.renderTable(1);
    },
    review: function (id, index) {
      this.$api.goods.commentstatus({ id: id, status: index }).then(res => {
        if (res.code == 200) {
          this.$Message.success(res.msg);
          this.renderTable();
        }
      });
    },

    remove: function (index) {
      // 弹出确认框
      this.$Modal.confirm({
        title: "警告",
        content: "<p>此操作不可恢复，三思而后行...</p>",
        onOk: () => {
          this.$api.goods.commentremove({ id: index }).then(res => {
            if (res.code == 200) {
              this.$Message.success(res.msg);
              this.getTableList();
            }
          });
        }
      });
    },
    // 筛选
    renderTable: function (name) {
      var self = this;
      var ps = {
        page: this.pages.current,
        size: this.pages.size,
        key: this.formItem.key
      };
      this.$api.goods.commentlist(ps).then(res => {
        this.dataloading = false;
        if (res.code == 200) {
          self.tablelist = res.result.list;
          this.pages.total = res.result.total;
          this.$Message.success(res.msg);
        }
      });
      return;
    }
  }
};
</script>


